import { Button } from '@components/core-ui/form-elements/buttons/Button/';

import { Modal } from '@modals/core-ui/Modal';

import { Title } from './styles/Title';
import { Wrapper } from './styles/Wrapper';

type TProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const DesktopTutorialVideo = ({ isOpen, onClose }: TProps) => {
  return (
    <Modal isOpen={isOpen} onClose={() => onClose()}>
      <Wrapper>
        <Title style={{ margin: '0 0 25px', textAlign: 'center' }}>AutoScript Desktop User Guide</Title>
        <video controls width="100%" poster="https://autoscript-assets.s3.us-east-1.amazonaws.com/video/Desktop.jpg">
          <source src="https://autoscript-assets.s3.us-east-1.amazonaws.com/video/Desktop.mp4" type="video/mp4" />
          <p>
            Your browser {"doesn't"} support HTML video. Here is a{' '}
            <a href="https://autoscript-assets.s3.us-east-1.amazonaws.com/video/Desktop.mp4">link to the video</a>{' '}
            instead.
          </p>
        </video>
        <div style={{ marginTop: '20px' }}>
          <Button onClick={onClose}>Got it!</Button>
        </div>
      </Wrapper>
    </Modal>
  );
};
